import { defineMessages } from 'react-intl';

export default defineMessages({

  ifYesPleaseProvide: {
    id: 'fastCover.medicalExpenseCFStep.ifYesPleaseProvide',
    defaultMessage: 'If so, please provide the Company Name and Address',
  },

  didYouHaveOtherMedicalInsurance: {
    id: 'fastCover.medicalExpenseCFStep.didYouHaveOtherMedicalInsurance',
    defaultMessage: 'Did you have other medical insurance?',
  },

  doYouHaveAnyOtherTypeOfCoverage: {
    id: 'fastCover.medicalExpenseCFStep.doYouHaveAnyOtherTypeOfCoverage',
    defaultMessage: 'Do you have any other type of coverage?',
  },

  address: {
    id: 'fastCover.medicalExpenseCFStep.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.medicalExpenseCFStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.medicalExpenseCFStep.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.medicalExpenseCFStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  policyId: {
    id: 'fastCover.medicalExpenseCFStep.policyId',
    defaultMessage: 'Policy ID',
  },

  contact: {
    id: 'fastCover.medicalExpenseCFStep.contact',
    defaultMessage: 'Contact',
  },

  email: {
    id: 'fastCover.medicalExpenseCFStep.email',
    defaultMessage: 'Email',
  },

  phoneNumber: {
    id: 'fastCover.medicalExpenseCFStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  zip: {
    id: 'fastCover.medicalExpenseCFStep.zip',
    defaultMessage: 'Zip',
  },

  areYouACitizenOfTheEuropeanUnion: {
    id: 'fastCover.medicalExpenseCFStep.areYouACitizenOfTheEuropeanUnion',
    defaultMessage: 'Are you a citizen of the European Union?',
  },

  forEUCitizens: {
    id: 'fastCover.medicalExpenseCFStep.forEUCitizens',
    defaultMessage: 'Was a European Health Insurance Card (EHIC) taken on this trip?',
  },

  ifYesWasTheEHIC: {
    id: 'fastCover.medicalExpenseCFStep.ifYesWasTheEHIC',
    defaultMessage: 'If yes, was the EHIC presented to the hospital or physician?',
  },

  ifNoPleaseExplain: {
    id: 'fastCover.medicalExpenseCFStep.ifNoPleaseExplain',
    defaultMessage: 'If no, please explain',
  },

  place: {
    id: 'fastCover.medicalExpenseCFStep.place',
    defaultMessage: 'Place',
  },

  expensesClaimed: {
    id: 'fastCover.medicalExpenseCFStep.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },

  currency: {
    id: 'fastCover.medicalExpenseCFStep.currency',
    defaultMessage: 'Currency',
  },


  yes: {
    id: 'fastCover.medicalExpenseCFStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.medicalExpenseCFStep.no',
    defaultMessage: 'No',
  },
  //---------------------------
  areYouClaimingForDamagedLostOrStolenLuggage: {
    id: 'fastCover.medicalExpenseCFStep.areYouClaimingForDamagedLostOrStolenLuggage',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },

  areYouClaimingForBaggageDelay: {
    id: 'fastCover.medicalExpenseCFStep.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },

  areYouClaimingFor: {
    id: 'fastCover.medicalExpenseCFStep.areYouClaimingFor',
    defaultMessage: 'Are you claiming for:',
  },

  travelSupplierProviderInformation: {
    id: 'fastCover.medicalExpenseCFStep.travelSupplierProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyYouWereTravelingWith: {
    id: 'fastCover.medicalExpenseCFStep.companyYouWereTravelingWith',
    defaultMessage: 'Company you were traveling with:',
  },

  origin: {
    id: 'fastCover.medicalExpenseCFStep.origin',
    defaultMessage: 'Origin',
  },

  flightNumber: {
    id: 'fastCover.medicalExpenseCFStep.flightNumber',
    defaultMessage: 'Flight Number',
  },

  lossInformation: {
    id: 'fastCover.medicalExpenseCFStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  dateOfLoss: {
    id: 'fastCover.medicalExpenseCFStep.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.medicalExpenseCFStep.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred',
  },

  whoDidYouReportTo: {
    id: 'fastCover.medicalExpenseCFStep.whoDidYouReportTo',
    defaultMessage: 'Who did you report to?',
  },

  reportReferenceNumber: {
    id: 'fastCover.medicalExpenseCFStep.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },

  nameAndAddress: {
    id: 'fastCover.medicalExpenseCFStep.nameAndAddress',
    defaultMessage: 'Name and Address',
  },

  nameCustomerServiceDepartment: {
    id: 'fastCover.medicalExpenseCFStep.nameCustomerServiceDepartment',
    defaultMessage: 'Name (Customer Service Department)',
  },

  doYouHaveAnyFurtherDetailsToAdd: {
    id: 'fastCover.medicalExpenseCFStep.doYouHaveAnyFurtherDetailsToAdd',
    defaultMessage: 'Do you have any further details to add',
  },

  loss: {
    id: 'fastCover.medicalExpenseCFStep.loss',
    defaultMessage: 'Loss',
  },

  theft: {
    id: 'fastCover.medicalExpenseCFStep.theft',
    defaultMessage: 'Theft',
  },

  damage: {
    id: 'fastCover.medicalExpenseCFStep.damage',
    defaultMessage: 'Damage',
  },

  tourOperator: {
    id: 'fastCover.medicalExpenseCFStep.tourOperator',
    defaultMessage: 'Tour Operator',
  },

  cruiseLine: {
    id: 'fastCover.medicalExpenseCFStep.cruiseLine',
    defaultMessage: 'Cruise Line',
  },

  airline: {
    id: 'fastCover.medicalExpenseCFStep.airline',
    defaultMessage: 'Airline',
  },

  airport: {
    id: 'fastCover.medicalExpenseCFStep.airport',
    defaultMessage: 'Airport',
  },

  hotel: {
    id: 'fastCover.medicalExpenseCFStep.hotel',
    defaultMessage: 'Hotel',
  },

  rentalAgency: {
    id: 'fastCover.medicalExpenseCFStep.rentalAgency',
    defaultMessage: 'Rental Agency',
  },

  police: {
    id: 'fastCover.medicalExpenseCFStep.police',
    defaultMessage: 'Police',
  },

  hospitalManagement: {
    id: 'fastCover.medicalExpenseCFStep.hospitalManagement',
    defaultMessage: 'Hospital Management',
  },

  cruiseShip: {
    id: 'fastCover.medicalExpenseCFStep.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },

  tourGuide: {
    id: 'fastCover.medicalExpenseCFStep.tourGuide',
    defaultMessage: 'Tour Guide',
  },

  notReported: {
    id: 'fastCover.medicalExpenseCFStep.notReported',
    defaultMessage: 'Not Reported',
  },

  addItem: {
    id: 'fastCover.medicalExpenseCFStep.addItem',
    defaultMessage: 'Add Item',
  },

  addDate: {
    id: 'fastCover.medicalExpenseStep.addDate',
    defaultMessage: 'Add Date',
  },

  itemWithIdx: {
    id: 'fastCover.medicalExpenseCFStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.medicalExpenseCFStep.item',
    defaultMessage: 'Item',
  },

  estimatedValue: {
    id: 'fastCover.medicalExpenseCFStep.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.medicalExpenseCFStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },

  fromWhom: {
    id: 'fastCover.medicalExpenseCFStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  howMuch: {
    id: 'fastCover.medicalExpenseCFStep.howMuch',
    defaultMessage: 'How much?',
  },

  totalExpensesClaimed: {
    id: 'fastCover.medicalExpenseCFStep.totalExpensesClaimed',
    defaultMessage: 'Total Expenses Claimed',
  },

  addPrescriptionMedicines: {
    id: 'fastCover.medicalExpenseCFStep.addPrescriptionMedicines',
    defaultMessage: 'Add Prescription medicine',
  },

  prescriptionMedicinesV1: {
    id: 'fastCover.medicalExpenseCFStep.prescriptionMedicinesV1',
    defaultMessage: 'Prescription medicines you have been prescribed for your injury or illness',
  },

  dosage: {
    id: 'fastCover.medicalExpenseCFStep.dosage',
    defaultMessage: 'Dosage',
  },

  nameOfPrescribingDoctor: {
    id: 'fastCover.medicalExpenseCFStep.nameOfPrescribingDoctor',
    defaultMessage: 'Name of Prescribing Doctor',
  },

  prescriptionMedicinesV2: {
    id: 'fastCover.medicalExpenseCFStep.prescriptionMedicinesYouHave',
    defaultMessage: 'Prescription medicines, herbal medications or vitamins you took prior to your effective date that are not related to your injury/illness',
  },

  // ------------------------------------------------------------------------------------

  tripCancellation: {
    id: 'fastCover.medicalExpenseCFStep.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  travelInterruption: {
    id: 'fastCover.medicalExpenseCFStep.travelInterruption',
    defaultMessage: 'Are you claiming for Travel Interruption?',
  },

  travelDelay: {
    id: 'fastCover.medicalExpenseCFStep.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.medicalExpenseCFStep.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.medicalExpenseCFStep.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.medicalExpenseCFStep.reasons2',
    defaultMessage: 'You Unforeseen Sickness or Injury or, the Sickness or Injury if a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.medicalExpenseCFStep.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity a Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country',
  },

  reasons4: {
    id: 'fastCover.medicalExpenseCFStep.reasons4',
    defaultMessage: 'or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.medicalExpenseCFStep.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  addressTravelInterruption: {
    id: 'fastCover.medicalExpenseCFStep.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.medicalExpenseCFStep.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.medicalExpenseCFStep.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.medicalExpenseCFStep.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.medicalExpenseCFStep.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  includedInPackage: {
    id: 'fastCover.medicalExpenseCFStep.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  addLossInformation: {
    id: 'fastCover.medicalExpenseCFStep.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.medicalExpenseCFStep.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.medicalExpenseCFStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.medicalExpenseCFStep.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.medicalExpenseCFStep.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.medicalExpenseCFStep.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.medicalExpenseCFStep.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateEnded: {
    id: 'fastCover.medicalExpenseCFStep.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.medicalExpenseCFStep.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  companyNameLoss: {
    id: 'fastCover.medicalExpenseCFStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.medicalExpenseCFStep.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.medicalExpenseCFStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.medicalExpenseCFStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  reasonsForDelay: {
    id: 'fastCover.medicalExpenseCFStep.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.medicalExpenseCFStep.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.medicalExpenseCFStep.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident en router to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.medicalExpenseCFStep.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.medicalExpenseCFStep.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.medicalExpenseCFStep.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.medicalExpenseCFStep.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.medicalExpenseCFStep.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.medicalExpenseCFStep.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.medicalExpenseCFStep.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.medicalExpenseCFStep.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.medicalExpenseCFStep.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.medicalExpenseCFStep.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.medicalExpenseCFStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.medicalExpenseCFStep.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.medicalExpenseCFStep.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.medicalExpenseCFStep.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  delay: {
    id: 'fastCover.medicalExpenseCFStep.delay',
    defaultMessage: 'Delay',
  },
  hotelManagement: {
    id: 'fastCover.medicalExpenseCFStep.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  otherDescription: {
    id: 'fastCover.medicalExpenseCFStep.otherDescription',
    defaultMessage: 'If yes, please describe',
  },
  descriptionOfItems: {
    id: 'fastCover.medicalExpenseCFStep.descriptionOfItems',
    defaultMessage: 'Description of items',
  },
  datePurchased: {
    id: 'fastCover.medicalExpenseCFStep.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.medicalExpenseCFStep.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.medicalExpenseCFStep.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  amountClaimed: {
    id: 'fastCover.medicalExpenseCFStep.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.medicalExpenseCFStep.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.medicalExpenseCFStep.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.medicalExpenseCFStep.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  claimed: {
    id: 'fastCover.medicalExpenseCFStep.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.medicalExpenseCFStep.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.medicalExpenseCFStep.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.medicalExpenseCFStep.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.medicalExpenseCFStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.medicalExpenseCFStep.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.medicalExpenseCFStep.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.medicalExpenseCFStep.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.medicalExpenseCFStep.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.medicalExpenseCFStep.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.medicalExpenseCFStep.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.medicalExpenseCFStep.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.medicalExpenseCFStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.medicalExpenseCFStep.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.medicalExpenseCFStep.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.medicalExpenseCFStep.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.medicalExpenseCFStep.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.medicalExpenseCFStep.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.medicalExpenseCFStep.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.medicalExpenseCFStep.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.medicalExpenseCFStep.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.medicalExpenseCFStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  // New Screen
  travelInformation: {
    id: 'fastCover.medicalExpenseCFStep.travelInformation',
    defaultMessage: 'Travel Information',
  },
  typeOfPolicy: {
    id: 'fastCover.medicalExpenseCFStep.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  isTheClaimTheResultOfASicknessOrInjury: {
    id: 'fastCover.medicalExpenseCFStep.isTheClaimTheResultOfASicknessOrInjury',
    defaultMessage: 'Is the claim the result of a Sickness/Accident',
  },
  natureOfSickness: {
    id: 'fastCover.medicalExpenseStfep.natureOfSickness',
    defaultMessage: 'Nature of Sickness',
  },
  accident: {
    id: 'fastCover.medicalExpenseCFStep.accident',
    defaultMessage: 'Accident',
  },
  date: {
    id: 'fastCover.medicalExpenseCFStep.date',
    defaultMessage: 'Date',
  },
  sickness: {
    id: 'fastCover.medicalExpenseCFStep.sickness',
    defaultMessage: 'Sickness',
  },
  injury: {
    id: 'fastCover.medicalExpenseCFStep.injury',
    defaultMessage: 'Injury',
  },
  fromDate: {
    id: 'fastCover.medicalExpenseCFStep.fromDate',
    defaultMessage: 'From',
  },
  toDate: {
    id: 'fastCover.medicalExpenseCFStep.toDate',
    defaultMessage: 'To',
  },
  wasThereAnyPreviousTreatmentForThisCondition: {
    id: 'fastCover.medicalExpenseCFStep.wasThereAnyPreviousTreatmentForThisCondition',
    defaultMessage: 'Was there any previous treatment for this condition?',
  },
  nameOfProvider: {
    id: 'fastCover.medicalExpenseCFStep.nameOfProvider',
    defaultMessage: 'Name Of Provider',
  },
  dateIncurred: {
    id: 'fastCover.medicalExpenseCFStep.dateIncurred',
    defaultMessage: 'Date Incurred',
  },
  amountOfBill: {
    id: 'fastCover.medicalExpenseCFStep.amountOfBill',
    defaultMessage: 'Amount Of Bill',
  },
  amountPaidByOtherInsurance: {
    id: 'fastCover.medicalExpenseCFStep.amountPaidByOtherInsurance',
    defaultMessage: 'Amount Paid by Other Insurance',
  },

  illnessOrAccidentStatement: {
    id: 'fastCover.medicalExpenseCFStep.illnessOrAccidentStatement',
    defaultMessage: 'ILLNESS/ACCIDENT STATEMENT',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.medicalExpenseCFStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateFirstTreated: {
    id: 'fastCover.medicalExpenseCFStep.dateFirstTreated',
    defaultMessage: 'Date First Treated',
  },

  nameOfPhysician: {
    id: 'fastCover.medicalExpenseCFStep.nameOfPhysician',
    defaultMessage: 'Name Of Physician',
  },

  datesOfTreatment: {
    id: 'fastCover.medicalExpenseCFStep.datesOfTreatment',
    defaultMessage: 'Date First Treated',
  },

  natureOfInjury: {
    id: 'fastCover.medicalExpenseCFStep.natureOfInjury',
    defaultMessage: 'Nature Of Injury',
  },
  treatmentDates: {
    id: 'fastCover.medicalExpenseCFStep.treatmentDates',
    defaultMessage: 'Treatment Dates',
  },
  treatmentDate: {
    id: 'fastCover.medicalExpenseCFStep.treatmentDate',
    defaultMessage: 'Treatment Date',
  },
  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.medicalExpenseCFStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },
  origination: {
    id: 'fastCover.medicalExpenseCFStep.origination',
    defaultMessage: 'Origination',
  },
  airCarrier: {
    id: 'fastCover.medicalExpenseCFStep.airCarrier',
    defaultMessage: 'Air Carrier',
  },
  destination: {
    id: 'fastCover.medicalExpenseCFStep.destination',
    defaultMessage: 'Destination',
  },
  nameOfAccident: {
    id: 'fastCover.medicalExpenseCFStep.nameOfAccident',
    defaultMessage: 'Name of Accident',
  },
  expenseFor: {
    id: 'fastCover.medicalExpenseCFStep.expenseFor',
    defaultMessage: 'Expense For',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/messages.js